import MapFallback from "@mirage/components/MapView/components/MapFallback";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import NoGeometryMessage from "@publicPortal/components/noGeometryMessage/NoGeometryMessage";
import { PPConstants } from "@shared/publicportal/constants";
import { IPlanningApplicationDetails } from "@shared/publicportal/contracts/IPlanningApplicationDetails";
import { lazy, Suspense } from "react";

const MapView = lazy(() =>
    import("@mirage/components/MapView/MapView").then((module) => {
        return { default: module.MapView };
    })
);

export const PAMapTab = (props: { planningApp: IPlanningApplicationDetails }) => {
    const [sessionValue] = useSessionStorage(PPConstants.AppName);
    const { clientSettings } = sessionValue;
    if (props.planningApp == null) {
        return null;
    }
    const mapView = (
        <MapView
            readOnly
            center={[clientSettings.MAP_CENTER_LAT, clientSettings.MAP_CENTER_LONG]}
            className="mapView__fullWidth"
            geometries={props.planningApp.geometry ? (JSON.parse(props.planningApp.geometry) as GeoJSON.GeoJSON) : undefined}
            masterLayer={
                clientSettings
                    ? {
                          layerUrl: clientSettings.MASTER_LAYER_URL,
                          attribution: clientSettings.MASTER_LAYER_ATTRIBUTION,
                      }
                    : undefined
            }
        />
    );
    const component = props.planningApp.geometry != null ? mapView : <NoGeometryMessage />;
    return <Suspense fallback={<MapFallback />}>{component}</Suspense>;
};
